import { ALLOW_TEST_MODE, APP_DOMAIN_ZONE, APP_LANGUAGE } from '@common/constants';
import config from '@config';
import { reactLocalStorage } from 'reactjs-localstorage';

// export const isDomainZone = (zone: keyof typeof config.domains) => {
//   if (ALLOW_TEST_MODE) {
//     const stored = reactLocalStorage.get<string>(APP_DOMAIN_ZONE);
//     if (stored) {
//       return zone === stored;
//     }
//   }
//   return config.domains[zone].includes(window.location.hostname);
// };

export const isDomainZone = (zone: string): boolean => {
  if (ALLOW_TEST_MODE) {
    const stored = reactLocalStorage.get<string>(APP_DOMAIN_ZONE);
    if (stored) {
      return zone === stored;
    }
  }
  return config.internalKey === zone;
};


export const getCountryCode = () => {
  if (ALLOW_TEST_MODE) {
    const stored = reactLocalStorage.get<any>(APP_DOMAIN_ZONE);
    if (stored && typeof stored === 'string') {
      return stored.toUpperCase();
    }
  }

  switch (config.internalKey) {
    case 'ua':
      return 'UA';
    case 'ru':
      return 'RU';
    case 'tj':
      return 'TJ';
    case 'uz':
      return 'UZ';
    case 'kg':
      return 'KG';
    case 'boxbet':
      return 'BS';
    case 'net':
    case 'org':
      return 'TJ';
    default:
      return 'TJ';
  }
};

export const getLanguage = () => {
  const lang = reactLocalStorage.get<string>(APP_LANGUAGE);
  if (lang) return lang;

  switch (config.internalKey) {
    case 'uz':
      return 'uz';
    case 'ua':
      return 'ua';
    case 'kg':
    case 'boxbet':
    default:
      return 'ru';
  }
};


// export const isHostInKeno = () => {
//   const hostName = window.location.hostname;
//   const inbetHosts: Record<string, boolean> = config.inbetHosts;
//   if (hostName === 'localhost') {
//     return true;
//   }
//   return inbetHosts[hostName] !== undefined && inbetHosts[hostName];
// };
//
// export const isDevMode = () => {
//   const stored = reactLocalStorage.get(APP_ENABLE_DEV_CONFIG);
//   return stored === 'true';
// };

// export const apiDomainZone = () => {
//   if (isDomainZone('uz')) {
//     return 'https://api.boxbet.org';
//   } else if (isDomainZone('kg')) {
//     return 'https://api.boxbet.org';
//   } else if (isDomainZone('boxbet')) {
//     return 'https://api.boxbet.org';
//   } else if (isDomainZone('ua')) {
//     return 'https://api.epicboom.com';
//   } else if (isDomainZone('ru')) {
//     return 'https://api.formula55.ru';
//   } else {
//     return 'https://api.formula55.tj';
//   }
// };